import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/** New tabs have no usable browser history. Keep return links inside the same organisation. */
export function detailReturnUrl(current: string, returnTo: unknown): string {
  const path = current.split(/[?#]/)[0];
  const org = path.match(/^\/organizations\/[^/]+\//)?.[0];
  if (typeof returnTo === 'string' && org && returnTo.startsWith(org)
      && !returnTo.includes('\\') && returnTo.split(/[?#]/)[0] !== path) return returnTo;
  return path.slice(0, path.lastIndexOf('/')) || '/';
}

@Injectable({ providedIn: 'root' })
export class BackNavigationService {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly entries: number[] = [];
  private restoredId: number | null = null;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationStart) this.restoredId = event.restoredState?.navigationId ?? null;
      if (event instanceof NavigationEnd) {
        const index = this.restoredId == null ? -1 : this.entries.indexOf(this.restoredId);
        if (index >= 0) this.entries.splice(index);
        else if (this.restoredId != null) this.entries.length = 0;
        this.entries.push(event.id);
      }
    });
  }

  back(): void {
    if (this.entries.length > 1) { this.location.back(); return; }
    const returnTo = this.router.parseUrl(this.router.url).queryParams['returnTo'];
    void this.router.navigateByUrl(detailReturnUrl(this.router.url, returnTo));
  }
}
